<template>
    <div>
        <b-table hover ref="billTable" :items="items" :fields="fieldTalbe" :filter="search"
        :per-page="search.perPage" :current-page="search.page" responsive show-empty>
        </b-table>
        <div class="mt-3">
            <b-pagination :value="search.page" @input="changePage" :total-rows="totalItems" :current-page="search.page" :per-page="search.perPage" align="right">
            </b-pagination>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        search: Object,
        items: [Array, Object],
        totalItems: String
    },
    data() {
        return {
            fieldTalbe: [
                {
                    key: "shop_id",
                    label: "SHOP ID",
                    sortable: true,
                },
                {
                    key: "tracking_code",
                    label: "Tracking Code",
                    sortable: true,
                },
                {
                    key: "courier_code",
                    label: "รหัสขนส่ง",
                    sortable: true,
                },
                {
                    key: "cod_amount",
                    label: "Cod Amount",
                    sortable: true,
                },
                {
                    key: "rcommission",
                    label: "ค่าคอมร้านสาขา",
                    sortable: true,
                },
                {
                    key: "sa_commission",
                    label: "ค่าคอม superadmin",
                    sortable: true,
                },
                {
                    key: "paid_shop_com",
                    label: "จ่ายร้านค้า",
                    sortable: true,
                },
                {
                    key: "paid_sa_com",
                    label: "จ่าย Super",
                    sortable: true,
                },
                {
                    key: "statusRegister",
                    label: "สถานะการลงทะเบียน",
                    sortable: true,
                },
            ]
        }
    },
    methods: {
        changePage(i) {
            if (this.search.page == i) return;
            this.search.page = i
        },
    }
}
</script>